import Dexie from 'dexie';

export const db = new Dexie('notas_realtime');

db.version(1).stores({
  lists: 'id, owner_user_id, group_id, updated_at, deleted_at',
  tasks: 'id, list_id, updated_at, deleted_at, completed',
  operations: 'op_id, status, created_at, scope_type, scope_id',
  meta: 'key',
});

export async function setMeta(key, value) {
  await db.meta.put({ key, value });
}

export async function getMeta(key, fallback = null) {
  const row = await db.meta.get(key);
  return row ? row.value : fallback;
}
